export default __webpack_public_path__ + "static/media/etabloc.8fb5743b.png";